module.exports = __webpack_public_path__ + "static/media/website_coupon_code_blur.81987e84.png";